//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

import warningIcon from '../../../../../assets/img/warningIcon.png';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';

type Props = {|
  open?: boolean,
  handleClose?: () => void,
  message?: string,
|};

const useStyles = makeStyles(() => ({
  titleModal: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#313135',
    textAlign: 'center',
  },
  bodyModal: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
    textAlign: 'center',
    marginTop: '8px',
  },
}));

export default function AlertCouponAlreadyUsedModal(props: Props) {
  const {open, handleClose, message} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div style={{maxWidth: '320px', padding: '24px', textAlign: 'center'}}>
        <div>
          <img src={warningIcon} alt="Warn icon" />
        </div>
        <br />
        <div className={classes.titleModal}>No se pudo editar el cupón</div>
        <div className={classes.bodyModal}>
          {message ||
            'Este cupón ya fue utilizado en un pedido. Solo puedes modificar el límite de usos y la fecha de expiración.'}
        </div>
        <br />
        <CustomButton variant="contained" color="primary" onClick={handleClose}>
          Entendido
        </CustomButton>
      </div>
    </CustomModal>
  );
}
